import { Flex } from '@chakra-ui/react';
import React from 'react';

import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PageHeader } from '~/packages/common-frontend/components/PageContainer';
import { OmniEmbedContainer } from '~/packages/omni/ui/OmniEmbedContainer';

/**
 * The lender's Omni analytics: the org's embed, landing on its
 * `omniConfig.analyticsDefaultPath` (e.g. the shared BUS portfolio dashboard).
 */
export const AnalyticsView = (): React.ReactElement => {
  const { user } = useUserAuthOrThrow();

  return (
    <Flex direction="column" padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}>
      <PageHeader headerLabel="Analytics" />
      <OmniEmbedContainer
        organizationId={user.organization.id}
        height="calc(100vh - 200px)"
      />
    </Flex>
  );
};
